module.exports = __webpack_public_path__ + "media/admin/cs_publication_002_sm-cd668cf1.png";